"use client";

import { ReactNode } from "react";
import { CampsiteProvider } from "@/lib/context/CampsiteProvider";

export function Providers({ children }: { children: ReactNode }) {
  return <CampsiteProvider>{children}</CampsiteProvider>;
}
